/**
 * Servicio de inicialización dinámica y gestión de Google Tag Manager (GTM)
 */

let isGTMInitialized = false;

/**
 * Inicializa dinámicamente el contenedor de GTM inyectando los scripts oficiales en head y body.
 * @param {string} gtmId - El ID del contenedor de GTM (ej. GTM-XXXXXXX)
 */
export function initializeGTM(gtmId) {
  if (!gtmId || typeof window === "undefined" || isGTMInitialized) return;

  // Evitar duplicados revisando si ya existe un elemento script de GTM
  const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`);
  if (existingScript) {
    isGTMInitialized = true;
    return;
  }

  try {
    // 1. Crear e inyectar el script en el <head>
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js"
    });

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    
    // Insertar antes del primer script existente
    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    // 2. Crear e inyectar el <noscript> en el <body> (fallback)
    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);

    if (document.body) {
      document.body.insertBefore(noscript, document.body.firstChild);
    } else {
      // Si el body no ha cargado del todo, esperar a que cargue
      window.addEventListener("DOMContentLoaded", () => {
        document.body.insertBefore(noscript, document.body.firstChild);
      });
    }

    isGTMInitialized = true;
  } catch (error) {
    console.error("Error al inicializar Google Tag Manager:", error);
  }
}

/**
 * Registra un evento de vista de página (virtual page view) en el dataLayer.
 * @param {string} path - La ruta virtual actual (pathname + search)
 * @param {string} title - El título de la página/documento
 * @param {Object} [additionalData] - Metadatos adicionales opcionales
 */
export function trackVirtualPageView(path, title, additionalData = {}) {
  if (typeof window === "undefined" || !window.dataLayer) return;

  window.dataLayer.push({
    event: "page_view",
    page_path: path,
    page_title: title || "We360",
    ...additionalData
  });
}
